import { AbstractControl } from '@angular/forms';
export function removeWhiteSpaces(control: AbstractControl) {
  if (control.value != null) {
    if (control.value.indexOf(' ') != -1) {
      control.setValue(control.value.replace(' ', ''));
    }
  }

  return null;
}